<div class="ds-dashboard" [ngClass]="{'dashboardData_show': showDashboard, 'dashboardData_hide': !showDashboard}">

  <!-- Skeleton Loader -->
  @if (!dashboardDataLoaded) {
    <div class="ds-welcome-section">
      <div class="skeleton skeleton-title" style="width: 280px; height: 32px;"></div>
      <div class="skeleton" style="width: 360px; height: 18px; margin-top: 8px;"></div>
      <div class="skeleton" style="width: 100%; height: 52px; margin-top: 16px; border-radius: 10px;"></div>
    </div>
    <div class="ds-stats-row">
      @for (i of [1,2,3,4]; track i) {
        <div class="skeleton skeleton-stat-card"></div>
      }
    </div>
    <div class="skeleton" style="width: 200px; height: 24px; margin-bottom: 1rem;"></div>
    <div class="skeleton" style="height: 280px; border-radius: 16px; margin-bottom: 1.5rem;"></div>
    <div class="skeleton" style="height: 200px; border-radius: 16px; margin-bottom: 1.5rem;"></div>
  }

  <!-- Dashboard Content -->
  @if (dashboardDataLoaded) {
    <!-- Welcome Section -->
    <div class="ds-welcome-section">
      <h1 class="ds-welcome-title">{{ 'dsGalleryDashboard.welcomeBack' | transloco: { galleryName: galleryName } }}</h1>
      <p class="ds-welcome-subtitle">{{ 'dsGalleryDashboard.welcomeSubtitle' | transloco }}</p>
      <div class="ds-tip-banner">
        <i class="fa fa-lightbulb-o"></i>
        <span><strong>{{ 'dsGalleryDashboard.proTip' | transloco }}</strong> {{ 'dsGalleryDashboard.proTipText' | transloco }}</span>
      </div>
    </div>
    <!-- Cockpit + at-a-glance hero (side-by-side on wide; tabs on small) -->
    <div class="gc-hero">
      <div class="gc-tabs">
        <button type="button" [class.active]="heroTab === 'attention'" (click)="heroTab = 'attention'">
          Needs attention @if (attentionTotal > 0) { <span class="gc-tab-badge">{{ attentionTotal }}</span> }
        </button>
        <button type="button" [class.active]="heroTab === 'glance'" (click)="heroTab = 'glance'">At a glance</button>
      </div>
      <div class="gc-cols">

        <!-- LEFT: what needs your attention -->
        <div class="gc-col gc-attention" [class.gc-hide-sm]="heroTab !== 'attention'">
          <div class="gc-col-head">
            <i class="fa fa-bell gc-col-icon"></i>
            <div>
              <h2 class="gc-col-title">What needs your attention</h2>
              <p class="gc-col-sub">
                @if (attentionTotal > 0) { {{ attentionTotal }} item(s) waiting on you today }
                @else { You're all caught up — nice work. }
              </p>
            </div>
          </div>

          @if (attentionTotal === 0) {
            <div class="gc-clear"><i class="fa fa-check-circle"></i><span>Nothing needs your attention right now.</span></div>
          }

          <div class="gc-queue">
            <button type="button" class="gc-q-card" [class.gc-has]="pendingAccept > 0" (click)="navigateToConsignmentProducts()">
              <span class="gc-q-icon gc-teal"><i class="fa fa-inbox"></i></span>
              <span class="gc-q-body"><span class="gc-q-label">Products to accept</span><span class="gc-q-sub">Consigned work awaiting your approval</span></span>
              <span class="gc-q-count">{{ pendingAccept }}</span>
            </button>
            <button type="button" class="gc-q-card" [class.gc-has]="pendingRequests > 0" (click)="navigateToRequestedProducts()">
              <span class="gc-q-icon gc-orange"><i class="fa fa-tags"></i></span>
              <span class="gc-q-body"><span class="gc-q-label">Requested products</span><span class="gc-q-sub">Products artists have requested</span></span>
              <span class="gc-q-count">{{ pendingRequests }}</span>
            </button>
            <button type="button" class="gc-q-card" [class.gc-has]="pendingConnections > 0" (click)="navigateToConnectedArtists()">
              <span class="gc-q-icon gc-teal"><i class="fa fa-user-plus"></i></span>
              <span class="gc-q-body"><span class="gc-q-label">New connection requests</span><span class="gc-q-sub">Artists asking to connect with you</span></span>
              <span class="gc-q-count">{{ pendingConnections }}</span>
            </button>
            <button type="button" class="gc-q-card" (click)="navigateToProposals()">
              <span class="gc-q-icon gc-orange"><i class="fa fa-file-text-o"></i></span>
              <span class="gc-q-body"><span class="gc-q-label">Proposals</span><span class="gc-q-sub">Review and respond to proposals</span></span>
              <i class="fa fa-arrow-right gc-q-arrow"></i>
            </button>
          </div>
        </div>

        <!-- RIGHT: at a glance (existing performance overview) -->
        <div class="gc-col gc-glance" [class.gc-hide-sm]="heroTab !== 'glance'">
    <!-- Stats Overview -->
    <div class="ds-stats-header">
      <h2 class="ds-stats-title">{{ 'dsGalleryDashboard.performanceOverview' | transloco }}</h2>
      <p class="ds-stats-subtitle">{{ 'dsGalleryDashboard.performanceSubtitle' | transloco }}</p>
    </div>
    <div class="ds-stats-row">
      <div class="ds-stat-card">
        <div class="ds-stat-icon ds-icon-teal">
          <i class="fa fa-users"></i>
        </div>
        <div class="ds-stat-content">
          <div class="ds-stat-value">{{ connectedArtistCount }}</div>
          <div class="ds-stat-label">{{ 'dsGalleryDashboard.connectedArtists' | transloco }}</div>
        </div>
      </div>
      <div class="ds-stat-card">
        <div class="ds-stat-icon ds-icon-orange">
          <i class="fa fa-picture-o"></i>
        </div>
        <div class="ds-stat-content">
          <div class="ds-stat-value">{{ galleryDashboardData.TotatUnSoldArtWorks || 0 }}</div>
          <div class="ds-stat-label">{{ 'dsGalleryDashboard.artworksInStock' | transloco }}</div>
        </div>
      </div>
      <div class="ds-stat-card">
        <div class="ds-stat-icon ds-icon-teal">
          <i class="fa fa-shopping-cart"></i>
        </div>
        <div class="ds-stat-content">
          <div class="ds-stat-value">{{ galleryDashboardData.ItemsSoldThisMonth || 0 }}</div>
          <div class="ds-stat-label">{{ 'dsGalleryDashboard.soldThisMonth' | transloco }}</div>
          @if (galleryDashboardData.ItemsSoldThisYear) {
            <div class="ds-stat-change">{{ 'dsGalleryDashboard.soldThisYear' | transloco: { count: galleryDashboardData.ItemsSoldThisYear } }}</div>
          }
        </div>
      </div>
      <div class="ds-stat-card">
        <div class="ds-stat-icon ds-icon-orange">
          <i class="fa fa-usd"></i>
        </div>
        <div class="ds-stat-content">
          <div class="ds-stat-value">{{ galleryDashboardData.RevenueThisMonth | currency:'USD':'symbol':'1.0-0' }}</div>
          <div class="ds-stat-label">{{ 'dsGalleryDashboard.revenueThisMonth' | transloco }}</div>
          @if (galleryDashboardData.RevenueYTD) {
            <div class="ds-stat-change">{{ 'dsGalleryDashboard.ytd' | transloco }} {{ galleryDashboardData.RevenueYTD | currency:'USD':'symbol':'1.0-0' }}</div>
          }
        </div>
      </div>
    </div>
        </div><!-- /gc-glance -->
      </div><!-- /gc-cols -->
    </div><!-- /gc-hero -->
    <!-- Curate/Engage/Track tips removed (round-1 increment B): overlapped the cockpit's purpose. -->
    <!-- Quick Actions removed: now covered by the icon rail (Inventory/Artists/Events/Selling/Website). -->
    <!-- Recent Activity Section -->
    <div class="ds-section">
      <div class="ds-section-header">
        <i class="fa fa-clock ds-section-icon"></i>
        <div>
          <h2 class="ds-section-title">{{ 'dsGalleryDashboard.newProducts' | transloco }}</h2>
          <p class="ds-section-subtitle">{{ 'dsGalleryDashboard.newProductsSubtitle' | transloco }}</p>
        </div>
      </div>
      <div class="ds-activity-content">
        <div class="container p-3">
          <div class="row">
            @if (!galleryDashboardData.NewProductsAdded || galleryDashboardData.NewProductsAdded.length === 0) {
              <div class="ds-empty-artwork">
                <i class="fa fa-picture-o"></i>
                <h4>{{ 'dsGalleryDashboard.noNewProductsYet' | transloco }}</h4>
                <p>{{ 'dsGalleryDashboard.noNewProductsText' | transloco }}</p>
                <div class="d-flex gap-2 justify-content-center">
                  <button pButton type="button" [label]="'dsGalleryDashboard.createProduct' | transloco" icon="pi pi-plus"
                  class="p-button-outlined p-button-sm" (click)="navigateToCreateProduct()"></button>
                  <button pButton type="button" [label]="'dsGalleryDashboard.connectArtists' | transloco" icon="pi pi-users"
                  class="p-button-outlined p-button-sm" (click)="navigateToConnectedArtists()"></button>
                </div>
              </div>
            }
            @if (galleryDashboardData.NewProductsAdded && galleryDashboardData.NewProductsAdded.length > 0) {
              <ds-artwork-grid context="gallery-new-products" #gnp class="d-block w-100">
                @for (product of galleryDashboardData.NewProductsAdded.slice(0, 6); track product) {
                  <ds-artwork-card
                    [size]="gnp.size"
                    [imageUrl]="product.ResizedImageUrl || product.Img"
                    [name]="product.Name"
                    [subtitle]="product.ArtTypeName"
                    [price]="product.Price"
                    (cardClick)="goToProductDetails(product)"></ds-artwork-card>
                }
              </ds-artwork-grid>
            }
          </div>
        </div>
        @if (galleryDashboardData.NewProductsAdded && galleryDashboardData.NewProductsAdded.length > 0) {
          <div class="ds-view-all">
            <a (click)="navigateToConsignmentProducts()">{{ 'dsGalleryDashboard.viewAllProducts' | transloco }} <i class="fa fa-arrow-right"></i></a>
          </div>
        }
      </div>
    </div>
    <!-- Top Performing Section -->
    @if (galleryDashboardData.BestPerformingArtistData && galleryDashboardData.BestPerformingArtistData.length > 0) {
      <div class="ds-section">
        <div class="ds-section-header">
          <i class="fa fa-star ds-section-icon"></i>
          <div>
            <h2 class="ds-section-title">{{ 'dsGalleryDashboard.topPerformingArtists' | transloco }}</h2>
            <p class="ds-section-subtitle">{{ 'dsGalleryDashboard.topPerformingArtistsSubtitle' | transloco }}</p>
          </div>
        </div>
        <div class="ds-activity-content">
          <div class="d-flex flex-column gap-2">
            @for (item of galleryDashboardData.BestPerformingArtistData; track item) {
              <div class="d-flex justify-content-between align-items-center p-2 rounded">
                <div class="text-uppercase fw-semibold" style="min-width: 150px;">{{ item.ArtistName }}</div>
                <div class="flex-grow-1 mx-3">
                  <div class="progress" style="height: 8px; border-radius: 4px;">
                    <div class="progress-bar" role="progressbar" [style.width.%]="item.PercentageOfTotal"
                      [ngClass]="item.ColorClassBasedOnPercentage"
                      style="border-radius: 4px;">
                    </div>
                  </div>
                </div>
                <div class="fw-bold" style="min-width: 60px; text-align: right;">{{ item.PercentageOfTotal }}%</div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    <!-- Top Art Types Section -->
    @if (galleryDashboardData.BestPerformingArtTypeData && galleryDashboardData.BestPerformingArtTypeData.length > 0) {
      <div class="ds-section">
        <div class="ds-section-header">
          <i class="fa fa-paint-brush ds-section-icon"></i>
          <div>
            <h2 class="ds-section-title">{{ 'dsGalleryDashboard.topArtTypes' | transloco }}</h2>
            <p class="ds-section-subtitle">{{ 'dsGalleryDashboard.topArtTypesSubtitle' | transloco }}</p>
          </div>
        </div>
        <div class="ds-activity-content">
          <div class="d-flex flex-column gap-2">
            @for (item of galleryDashboardData.BestPerformingArtTypeData; track item) {
              <div class="d-flex justify-content-between align-items-center p-2 rounded">
                <div class="text-uppercase fw-semibold" style="min-width: 150px;">{{ item.ArtTypeName }}</div>
                <div class="flex-grow-1 mx-3">
                  <div class="progress" style="height: 8px; border-radius: 4px;">
                    <div class="progress-bar" role="progressbar" [style.width.%]="item.PercentageOfTotal"
                      [ngClass]="item.ColorClassBasedOnPercentage"
                      style="border-radius: 4px;">
                    </div>
                  </div>
                </div>
                <div class="fw-bold" style="min-width: 60px; text-align: right;">{{ item.PercentageOfTotal }}%</div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    <!-- Gallery Overview Card -->
    <div class="ds-section">
      <div class="ds-section-header">
        <i class="fa fa-building ds-section-icon"></i>
        <div>
          <h2 class="ds-section-title">{{ 'dsGalleryDashboard.galleryOverview' | transloco }}</h2>
          <p class="ds-section-subtitle">{{ 'dsGalleryDashboard.galleryOverviewSubtitle' | transloco }}</p>
        </div>
      </div>
      <div class="ds-portfolio-content">
        <div class="ds-portfolio-card">
          <div class="ds-portfolio-icon">
            <i class="fa fa-bar-chart"></i>
          </div>
          <div class="ds-portfolio-info">
            <div class="ds-portfolio-status">{{ 'dsGalleryDashboard.stockValue' | transloco }} {{ galleryDashboardData.TotalValueOfUnSoldArtworks | currency:'USD':'symbol':'1.0-0' }}</div>
            <div class="ds-portfolio-stats">
              <span><i class="fa fa-clock-o"></i> {{ 'dsGalleryDashboard.turnoverDays' | transloco: { count: (galleryDashboardData.TurnoverRate30Days || 0) } }}</span>
              <span><i class="fa fa-inbox"></i> {{ 'dsGalleryDashboard.pendingApprovals' | transloco: { count: (galleryDashboardData.ConsignmentApprovalPending?.length || 0) } }}</span>
              <span><i class="fa fa-envelope"></i> {{ 'dsGalleryDashboard.connectionRequests' | transloco: { count: (galleryDashboardData.IncomingGalleryConnectionRequest?.length || 0) } }}</span>
            </div>
          </div>
          <div class="ds-portfolio-actions">
            <button pButton type="button" [label]="'dsGalleryDashboard.requests' | transloco" icon="pi pi-inbox"
            class="p-button-outlined p-button-sm" (click)="navigateToRequestedProducts()"></button>
            <button pButton type="button" [label]="'dsGalleryDashboard.proposals' | transloco" icon="pi pi-file"
            class="p-button-outlined p-button-sm" (click)="navigateToProposals()"></button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
